module.exports = __webpack_public_path__ + "static/media/credit-cards.d5452bc9.svg";